import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ecf9d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modify-role" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改密码", -1))
const _hoisted_4 = { style: {"color":"#FF0000"} }
const _hoisted_5 = { class: "con" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"100%"} }, "密码至少包含三种或三种以上大写字母、小写字母、数字和特殊符号（@%&#）组合，密码长度在8~16位之间。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.needChangePassword)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "iconfont icon-guanbi",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModifyModal && _ctx.closeModifyModal(...args)))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.needChangePassword), 1),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_mas_form_main, {
        form: _ctx.form.formValue,
        ruleForm: _ctx.form.ruleForm,
        defaultFormFooterButton: ['confirm', 'cancel'],
        onConfim: _ctx.modifyPassword,
        labelWidth: "100px",
        onCancel: _ctx.closeModifyModal
      }, {
        content: _withCtx((slotProps) => [
          _createVNode(_component_el_form_item, {
            label: "原密码",
            prop: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: slotProps.content.password,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.password) = $event),
                clearable: "",
                placeholder: "请输入原密码",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFormChange(_ctx.form.formValue))),
                type: "password",
                "show-password": ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "新密码",
            prop: "newPassword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: slotProps.content.newPassword,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.newPassword) = $event),
                clearable: "",
                placeholder: "请输入新密码",
                type: "password",
                "show-password": ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _hoisted_6
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "确认新密码",
            prop: "aginNewPassword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: slotProps.content.aginNewPassword,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.aginNewPassword) = $event),
                clearable: "",
                placeholder: "请确认输入新密码",
                type: "password",
                "show-password": ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["form", "ruleForm", "onConfim", "onCancel"])
    ])
  ]))
}